import { useGlobalMapActions } from "contexts/map";
import * as S from "./styles";
import { OccurrenceMarkerCard } from "../OccurrenceMarkerCard";
import { IMapLocationData } from "contexts/map/types";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import { useState } from "react";

import OccurrenceModal from "components/Modals/OccurrenceManagementModal";
import { PolicemanMarkerCard } from "../PolicemanMarkerCard";

export function MapMarkerList() {
  const {
    markers,
    selectedMarker,
    handleFavoriteClick,
    handleMapCenterChange,
  } = useGlobalMapActions();

  const { setOccurrenceToEditId } = useManualOccurrence();

  const [isOccurrenceModalOpen, setIsOccurrenceModalOpen] =
    useState<boolean>(false);

  function handleCardFavoriteClick(marker: IMapLocationData) {
    handleFavoriteClick({
      location: marker,
      type: "occurrence",
    });
  }

  function handleOccurrenceMoreDetailsClick(occurrenceId: string) {
    setOccurrenceToEditId(occurrenceId);
    setIsOccurrenceModalOpen(true);
  }

  if (markers.length === 0) {
    return (
      <S.EmptyWrapper>
        <h3>Nenhuma localização encontrada</h3>
      </S.EmptyWrapper>
    );
  }

  return (
    <div>
      {markers.map((marker) => {
        if (marker.type === "patrimony" || marker.type === "vehicle") {
          return (
            <OccurrenceMarkerCard
              marker={marker}
              isSelected={selectedMarker?.dataId === marker.dataId}
              onFavoriteClick={() => handleCardFavoriteClick(marker)}
              onMapLocationChange={handleMapCenterChange}
              onMoreDetailsClick={handleOccurrenceMoreDetailsClick}
            />
          );
        }

        if (
          marker.type === "free-policeman" ||
          marker.type === "working-policeman"
        ) {
          return (
            <PolicemanMarkerCard
              marker={marker}
              isSelected={selectedMarker?.dataId === marker.dataId}
              onFavoriteClick={() => handleCardFavoriteClick(marker)}
              onMapLocationChange={handleMapCenterChange}
            />
          );
        }

        return undefined;
      })}

      {isOccurrenceModalOpen && (
        <OccurrenceModal
          type={"patrimonial"}
          isOpen={isOccurrenceModalOpen}
          setIsOpen={() => setIsOccurrenceModalOpen(false)}
        />
      )}
    </div>
  );
}
